module.exports = __webpack_public_path__ + "source/img/elder.fd574985.svg";